module.exports = __webpack_public_path__ + "static/media/logo@1x.3644270a.png";